import { apiGet } from '../../generic/Api_Functions'
import { getRandomUUID } from '../../generic/utilities/randomuuid'
import { hydrateWorkflowTree } from './cascadeApproval'
import { clearTempDocumentScopes } from './tempDocumentScopes'

/**
 * Loads the full workflow tree (every not-yet-loaded subworkflow, recursively) so an index
 * cascade can reach the nodes inside nested subworkflows. Fetched subworkflows get the same
 * client-side bookkeeping fields `handleSubWorkflowDoubleClick` sets when it lazy-loads them, so
 * opening a subworkflow after the cascade reuses the in-memory (cascaded) object instead of
 * re-fetching the persisted, pre-cascade values.
 *
 * @param {import('../../generic/utilities/objectStructures/workflow/workflow').Workflow} workflow
 * @returns {Promise<import('../../generic/utilities/objectStructures/workflow/workflow').Workflow>}
 */
export const loadFullWorkflowTree = (workflow) => hydrateWorkflowTree(workflow, async (workflowId) => {
  const response = await apiGet('workflow/' + workflowId)
  response.tempWorkflowUUID = getRandomUUID()
  clearTempDocumentScopes(response)
  return response
})
